module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [(_vm.$route.name !== "contact us") ? _c('div', {
    staticClass: "footer__container--top"
  }, [_c('div', {
    attrs: {
      "id": "contact-us"
    }
  }), _c('HomeForm', [_c('MainForm')], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "footer__container--bottom"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__left"
  }, [_c('div', {
    staticClass: "footer__left--top"
  }, _vm._l((_vm.icons), function(item, i) {
    return _c('img', {
      key: i,
      staticClass: "footer__icons-image",
      attrs: {
        "alt": "partner",
        "src": item.image
      }
    })
  }), 0), _c('div', {
    staticClass: "footer__left--bottom"
  }, [_c('div', {
    staticClass: "footer__appointment-buttons"
  }, [_c('div', {
    staticClass: "footer__appointment-button",
    class: {
      'footer__appointment-button--open': _vm.isOpen
    },
    on: {
      "click": _vm.dropup
    }
  }, [(!_vm.isOpen) ? _c('span', [_vm._v("Make Appointment")]) : _vm._e(), (_vm.isOpen) ? _c('span', [_vm._v("Close")]) : _vm._e(), _c('div', {
    staticClass: "footer__appointment-link"
  }, [_c('div', {
    staticClass: "footer__dropup",
    staticStyle: {
      "top": "-56px"
    }
  }, [_c('a', {
    staticClass: "footer__dropup-form-link",
    attrs: {
      "href": "https://www.anywheredolphin.com/forms/lakenonaorthodontics.com/-fikhon8YkWCNuinG1vkCA",
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s("Lake Nona Schedule Online")
    }
  })]), _c('div', {
    staticClass: "footer__dropup",
    staticStyle: {
      "top": "-87px"
    }
  }, [_c('FunctionButton2', {
    staticClass: "footer__dropup-form-link",
    attrs: {
      "content": _vm.button,
      "function1": _vm.openModal
    }
  }, [_vm._v("Email Us")])], 1), _c('div', {
    staticClass: "footer__dropup",
    staticStyle: {
      "top": "-118px"
    }
  }, [_c('a', {
    staticClass: "footer__dropup-form-link",
    attrs: {
      "href": "tel:+14076271187"
    },
    domProps: {
      "innerHTML": _vm._s("Call Us")
    }
  })])])]), _c('router-link', {
    staticClass: "footer__appointment-button",
    attrs: {
      "id": "tour",
      "to": '/about-us#panowalks1'
    }
  }, [_vm._v("OFFICE TOUR")])], 1)])]), _c('div', {
    staticClass: "footer__center"
  }, [_c('div', {
    staticClass: "footer__top"
  }, [_vm._l((_vm.information), function(info) {
    return _c('div', {
      staticClass: "footer__links"
    }, [_c('a', {
      staticClass: "footer__link",
      attrs: {
        "href": info.path
      },
      domProps: {
        "innerHTML": _vm._s(info.text)
      }
    })])
  }), _c('div', {
    staticClass: "footer__top--text"
  }, [_vm._v("Se Habla Español")])], 2), _c('div', {
    staticClass: "footer__middle"
  }, _vm._l((_vm.social), function(item) {
    return _c('div', {
      staticClass: "footer__links--icons"
    }, [_c('a', {
      staticClass: "footer__link",
      attrs: {
        "aria-label": "sociallink",
        "href": item.path
      }
    }, [_c('Icon', {
      attrs: {
        "name": item.icon
      }
    })], 1)])
  }), 0)]), _c('div', {
    staticClass: "footer__right"
  }, [_c('div', {
    staticClass: "footer__button"
  }, [_c('ScrollButton', {
    attrs: {
      "content": _vm.button,
      "scroll": {
        el: "#top",
        duration: 1250,
        easing: [0.445, 0.05, 0.55, 0.95],
        offset: -50,
        cancelable: true,
        x: false,
        y: true
      }
    }
  }, [_c('div', {
    staticClass: "footer__button--chevron"
  }, [_c('span'), _c('span')])])], 1)])])]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__bottom"
  }, [_c('a', {
    staticClass: "footer__bottom-link",
    attrs: {
      "aria-label": "Part of Sakowitz Smiles Group",
      "href": "https://sakowitzsmiles.com",
      "target": "_blank"
    }
  }, [_vm._v("Part of Sakowitz Smiles Group")]), _c('a', {
    staticClass: "footer__bottom-link",
    attrs: {
      "aria-label": "Online Advantage by ROOSTER GRIN MEDIA",
      "href": "https://www.roostergrin.com/",
      "target": "_blank"
    }
  }, [_vm._v("Online Advantage by ROOSTER GRIN MEDIA")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cf2ee1f","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 601
// module chunks = 1